import { createFileRoute, notFound } from "@tanstack/react-router";

import { LegalPage, isPublicLocale, legalHead } from "@/components/legal-page";

export const Route = createFileRoute("/$lang/privacy")({
  beforeLoad: ({ params }) => {
    if (!isPublicLocale(params.lang)) throw notFound();
  },
  head: ({ params }) => legalHead("privacy", params.lang),
  component: RouteComponent,
});

function RouteComponent() {
  const { lang } = Route.useParams();
  return <LegalPage slug="privacy" lang={lang} />;
}
